import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setForm } from '../actions/formulaire'
import { Link } from 'react-scroll'
import carlos from '../images/carlos.gif'
import paillette from '../images/paillette.gif'
import what from '../images/what.gif'
import {Icon} from 'react-fa'

class Formules extends Component {

  selectFormule(formule){
    this.props.setForm({seance : formule});
  }

  render() {
    return (
      <div id="formules" className="formules">
        <div className="container">
          <h3>Choisissez entre nos trois formules !</h3>
          <div className="">
            <div className="col-3">
              <div className="circle"><img src={what}/></div>
              <h2>U <br/>QUOI ? </h2>
              <p>
                  UX, UI, Ixd, DS mais quel charabia ! Quel est le bon process pour mon projet numérique ?
              </p>
              <p className="formule">Cette formule comprend :</p>
              <div className="contenu"><Icon name="check" color="#E75535"/><p>une formation</p></div>
              <div className="contenu"><Icon name="check" color="#E75535"/><p >un petit déj</p></div>
              <div className="price">0</div>
              <div className="select-offre">
                <Link onClick={() => this.selectFormule("ux")} to="form" spy={true} smooth={true} duration={500}>
                  Choisir
                </Link>
              </div>
            </div>
            <div className="col-3">
              <div className="circle"><img src={carlos}/></div>
              <h2>DATA doudou dis donc !</h2>
              <p>
                Big data, big bisou…<br/> Smart data, smarties…<br/> la vérité est ailleurs !
              </p>
              <p className="formule">Cette formule comprend :</p>
              <div className="contenu"><Icon name="check" color="#E75535"/><p>une formation</p></div>
              <div className="contenu"><Icon name="check" color="#E75535"/><p >un petit déj</p></div>
              <div className="price">0</div>
              <div className="select-offre">
                <Link onClick={() => this.selectFormule("dataviz")} to="form" spy={true} smooth={true} duration={500}>
                  Choisir
                </Link>
              </div>
            </div>
            <div className="col-3">
              <div className="circle"><img src={paillette}/></div>
              <h2>Pompom <br/>pé dup !</h2>
              <p>
                Com’ digitale… Architecture connectée… Internet qui fait de l’objet… WTF !
              </p>

              <p className="formule">Cette formule comprend :</p>
              <div className="contenu"><Icon name="check" color="#E75535"/><p>une formation</p></div>
              <div className="contenu"><Icon name="check" color="#E75535"/><p >un petit déj</p></div>
              <div className="price">0</div>
              <div className="select-offre">
                <Link onClick={() => this.selectFormule("sceno")} to="form" spy={true} smooth={true} duration={500}>
                  Choisir
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    setForm : setForm
  },dispatch)
}

function mapStateToProps(state) {
  return {
    form : state.form
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Formules);



// WEBPACK FOOTER //
// ./src/client/components/formules.js